import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useAppDispatch } from "../../../app/hooks";
import CommentInputBox from "../../../common/components/functional/comments/CommentInputBox";
import { AddTalentComment } from "../../talents/types/commands";
import { addTalentComment } from "./TalentCommentsSlice";

type Props = {
  authorId: string;
  firstName: string;
  lastName: string;
};

const AddComment = ({ authorId, firstName, lastName }: Props) => {
  const { t } = useTranslation("talentProfile");
  const { talentId } = useParams();
  const dispatch = useAppDispatch();

  const handleSend = async (text: string) => {
    const commandPayload: AddTalentComment = {
      talentId: talentId as string,
      comment: text,
      authorId,
      authorFirstName: firstName,
      authorLastName: lastName,
    };
    await dispatch(addTalentComment(commandPayload));
  };

  return (
    <CommentInputBox
      firstName={firstName}
      lastName={lastName}
      placeholder={t("addComment")}
      onSend={handleSend}
    />
  );
};

export default AddComment;
